"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const FilterItems_1 = require("./FilterItems");
class ColumnFilter extends React.Component {
    constructor(props) {
        super(props);
        this.resetFilter = () => {
            this.props.onFilterReset(this.props.groupValue);
        };
        this.closeFilter = () => {
            const { tableWrapperEl } = this.props;
            this.props.close();
            tableWrapperEl.removeEventListener('scroll', this.closeFilter);
        };
        this.state = {
            headerCellWidth: null,
            headerCellHeight: null,
            headerCellLeft: null,
        };
    }
    componentDidMount() {
        const { width, height, left } = this.props.getHeaderDetails(this.props.name);
        const { tableWrapperEl } = this.props;
        tableWrapperEl.addEventListener('scroll', this.closeFilter);
        this.setState({ headerCellWidth: width, headerCellHeight: height, headerCellLeft: left });
    }
    componentDidUpdate() {
        const { width, height, left } = this.props.getHeaderDetails(this.props.name);
        if (width === null || height === null || left === null)
            return;
        if (width !== this.state.headerCellWidth ||
            height !== this.state.headerCellHeight ||
            left !== this.state.headerCellLeft) {
            this.setState({ headerCellWidth: width, headerCellHeight: height, headerCellLeft: left });
        }
    }
    componentWillUnmount() {
        const { tableWrapperEl } = this.props;
        tableWrapperEl.removeEventListener('scroll', this.closeFilter);
    }
    render() {
        const { resetFilterLabel, firstColumn, lastColumn } = this.props;
        const { headerCellWidth, headerCellHeight, headerCellLeft } = this.state;
        const hiddenColumn = headerCellWidth === 0 && headerCellHeight === 0;
        const additionalPixels = !lastColumn ? 70 : 0;
        const closeBtnPosition = !lastColumn ? '-left-[3px]' : 'right-[5px] left-auto';
        return ((0, jsx_runtime_1.jsxs)("div", { className: 'column-filter p-2xs border-secondary rounded-context-menu-border-radius bg-white shadow-[0_10px_12px_0_#d8d8d9] text-primary left-0 m-0 absolute text-left top-0 mobile:hidden z-[1] ' +
                (firstColumn ? 'column-filter--first [&_.column-filter__head-wrapper]:pl-5 ' : '') +
                (lastColumn ? 'column-filter--last [&_.column-filter__head-wrapper]:pr-5  ' : '') +
                (hiddenColumn ? 'column-filter--hidden hidden' : ''), style: {
                minWidth: headerCellWidth ? `${headerCellWidth}px` : 'auto',
                left: `${headerCellLeft + additionalPixels}px`,
                top: '30px',
            }, children: [(0, jsx_runtime_1.jsx)("span", { className: `cursor-pointerinline-block w-[80%] h-[28px] absolute -top-[23px] ${closeBtnPosition} column-filter__close`, onClick: this.closeFilter }), (0, jsx_runtime_1.jsx)("button", { onClick: this.resetFilter, className: "w-full column-filter__reset px-md py-xs hover:bg-fill-primary-hovered active:bg-fill-primary-pressed font-regular rounded-2xl", children: resetFilterLabel }), (0, jsx_runtime_1.jsx)("div", { className: "border-secondary my-2xs w-full border-b", "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)("div", { className: "column-filter__items", children: (0, jsx_runtime_1.jsx)(FilterItems_1.default, Object.assign({}, this.props)) })] }));
    }
}
exports.default = ColumnFilter;
